import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { 
    Flex, 
    Text, 
    Input,
    Button
} from "@chakra-ui/react";
import withNavElements from "../../components/withNavElements";
import { getUsers } from "../../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import UsersTable from "./UsersTable";
import NewUserModal from "./NewUserModal";
import EditUserModal from "./EditUserModal";
import { IoMdArrowBack } from "react-icons/io";
import { useHistory } from "react-router-dom";


const TEXT_TIME_TYPING = 500;
let typingTimer = null;

const DashboardUsersPage = () => {
  const history = useHistory();
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [showNewUserModal, setShowNewUserModal] = useState(false)
  const [editUser, setEditUser] = useState(null)
  const usersList = useSelector(state => state.userList)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getUsers({ page, limit }))
  }, [page, limit, dispatch]);

  const onChangeText = (e) => {
    const searchTerm = e.target.value;
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
        dispatch(getUsers({page: 1, limit: 10, searchTerm}));
    }, TEXT_TIME_TYPING);
  }

  return (
    <>
      <NewUserModal 
        isOpen={showNewUserModal}
        onClose={() => setShowNewUserModal(false)}
      />
      <EditUserModal 
        isOpen={editUser !== null}
        onClose={() => setEditUser(null)}
        userInfo={editUser}
      />
      
      <Helmet>
        <title>Dashboard - Users</title>
      </Helmet>
      <Flex
        flex={1}
        minH="300px"
        h="100%"
        mt="70px"
        py="40px"
        px={{ base: 0, md: "20px" }}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Flex 
          w='100%'
          justifyContent='center'
          alignItems='center'
          pos='relative'
        >
          <Button
            variant="ghost"
            pos='absolute'
            left='0'
            onClick={() => history.goBack()}
          >
            <IoMdArrowBack size='25px' />
          </Button>
          <Text fontSize="1.5em" fontWeight="400" >
            Gestión de Usuarios
          </Text>
        </Flex>
        <Flex
          mt="40px"
          w="100%"
          pt="50px"
          pb="80px"
          px={{ base: "40px", md: "40px" }}
          flex={1}
          minH="100%"
          bg="gray.100"
          borderRadius="10px"
          justifyContent="center"
          alignItems="end"
          flexDir={"column"}
        >
            <Input 
              w='200px'
              type='text'
              placeholder="Buscar usuario..."
              bg={usersList.loading ? 'gray.200' : 'white'}
              mb='20px'
              size='sm'
              onChange={onChangeText}
              borderRadius='8px'
            />
            <UsersTable 
                users={usersList.users}
                loading={usersList.loading}
                error={usersList.error}
                currentPage={usersList.currentPage}
                totalPages={usersList.totalPages}
                page={page}
                setPage={setPage}
                limit={limit}
                setLimit={setLimit}
                openNewUserModal={() => setShowNewUserModal(true)}
                openEditUserModal={(user) => setEditUser(user)}
            />
        </Flex>
      </Flex>
    </>
  );
};

export default withNavElements(DashboardUsersPage);
